<template>
  <div class="beer-collect-wrapper">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="back" />
        </template>
      </van-nav-bar>
    </div>

    <div class="content-wrapper">
      <MyPLabel class="title-wrapper" :str="$t('lang.beer.title')" :customClass="{ beer: 'beeract-title-beer' }" />

      <div class="goods-wrapper">
        <div class="mine-wrapper">
          <span>{{ $t('lang.beer.left') }}：</span>
          <img src="@/assets/packageAssets/common/beer.png" alt="icon" width="18" height="18" />
          <span>&nbsp;{{ beerRemainAmount }}</span>
        </div>
        <MyPLabel class="tips-wrapper" :str="$t('lang.beer.tips')" :customClass="{ beer: 'beeract-tips-beer' }" />

        <!-- 商品列表 -->
        <div class="goods-list">
          <div v-if="goodsLoading" class="goods-loading-wrapper">
            <van-loading />
          </div>
          <template v-else>
            <template v-for="item in goodsList">
              <div class="goods-item-wrap" :key="item.propType" @click="handleOpenPopup(item)">
                <div class="goods-item">
                  <!-- 蒙层 -->
                  <div class="shadow-mark" v-if="item.propType == 0 && ifExchangeCoinToday">
                    {{ $t('lang.beer.comeTomorrow') }}
                  </div>
                  <!-- 提示 -->
                  <div class="item-title">
                    <template v-if="item.propType == 0">
                      <span>{{ $t('lang.beer.onceDaily') }}</span>
                    </template>
                    <template v-else>
                      <span>{{ $t('lang.beer.unlimited') }}</span>
                    </template>
                  </div>
                  <div class="item-image">
                    <PropsImg :propType="item.propType" width="50" height="50" />
                    <div class="item-number">x{{ item.rewardAmount }}</div>
                  </div>
                  <div :class="['item-footer', beerRemainAmount < item.costBeerAmount ? 'item-footer-off' : '']">
                    <span>{{ $t('lang.beer.redeem') }}&nbsp;(</span>
                    <img src="@/assets/packageAssets/common/beer.png" alt="icon" width="18" height="18" />
                    <span>x{{ item.costBeerAmount }})</span>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>

      <!-- 兑换历史 -->
      <div class="history-wrapper">
        <div class="title">
          <MyPLabel :str="$t('lang.beer.historyTitle')" :customClass="{ beer: 'beeract-histit-beer' }" />
        </div>

        <!-- 历史列表 -->
        <div class="history-list-wrapper">
          <van-list
            class="list-wrapper"
            v-model="historyloading"
            offset="100"
            :finished="historyFinished"
            :loading-text="' '"
            :finished-text="historyList.length > 5 ? $t('lang.noMore') : ' '"
            @load="handleGetHistoryMore"
          >
            <template v-for="item in historyList">
              <div :key="item.propType" class="history-item">
                <div class="item-left">
                  <PropsImg :propType="item.propType" width="36" height="36" />
                  <span class="item-title">{{ getPropsName(item.propType) || '' }}{{ item.rewardAmount > 1 && item.propType !== 0 ? `*${item.rewardAmount}` : '' }}</span>
                </div>
                <div class="item-right">
                  <div class="item-info">
                    <span>{{ item.costBeerAmount }}&nbsp;</span>
                    <img src="@/assets/packageAssets/common/beer.png" alt="icon" width="18" height="18" />
                  </div>
                  <span class="item-time">{{ item.exchangeTime || '-' }}</span>
                </div>
              </div>
            </template>
          </van-list>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="popupVisible" title="" :className="'beer-van-dia'" :showConfirmButton="false" :showCancelButton="false">
      <div class="dialog-wrapper">
        <div class="title-wrapper">{{ $t('lang.beer.confirmRedemption') }}</div>
        <div class="content-wrapper">
          <div class="image-wrapper">
            <PropsImg :propType="currentItem.propType" width="40" height="40" />
          </div>
          <div class="text-wrapper">{{ getPropsName(currentItem.propType) || '' }} x {{ submitNumber }}</div>
          <div class="number-wrapper">
            <van-stepper v-model="submitNumber" step="1" min="1" button-size="40px" :max="maxNumber" integer disable-input :disabled="currentItem.propType === 0" />
          </div>
        </div>
        <div class="footer-wrapper">
          <div class="button-wrapper confirm" @click="handleSubmit">
            {{ $t('lang.confirm') }}
          </div>
          <div class="button-wrapper cancel" @click="handleClosePopup">
            {{ $t('lang.cfm.cancelBtn') }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiBeerExchangeList, apiBeerExchangeHistory, apiBeerExchange } from './apidir/api.js'

import PropsImg from '@/components/PropsImg/index.vue'

const mockList = [
  {
    propType: 0,
    rewardAmount: 12,
    costBeerAmount: 12,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 1,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 2,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 5,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 15,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  }
]

export default {
  name: 'beer-collect',
  components: { PropsImg },
  data() {
    return {
      // 我的啤酒量
      beerRemainAmount: 0,
      // 今天是否已经换完最终大奖
      ifExchangeCoinToday: false,
      goodsLoading: false,
      // 礼物列表
      goodsList: [],
      popupVisible: false,
      currentItem: {},
      // 历史列表
      historyList: [],
      mockHisList: mockList,
      rollParams: {
        offset: 0,
        limit: 10
      },
      historyloading: true,
      historyFinished: true,
      // 提交兑换的个数
      submitNumber: 1,
      // 最大的个数
      maxNumber: 1
    }
  },
  computed: {
    handleCheckExchange() {
      if (!this.currentItem.costBeerAmount) {
        return true
      }
      if (this.currentItem.propType === 0) {
        return true
      }
      if ((this.submitNumber + 1) * this.currentItem.costBeerAmount > this.beerRemainAmount) {
        return true
      }
      return false
    }
  },
  mounted() {
    this.handleGetList()
    this.handleGetHistory()
  },
  methods: {
    getPropsName(type) {
      const nameMap = {
        0: this.packageName === 'echo' ? '100 Gems' : '100 Coins',
        1: 'Chat Pass',
        2: 'Match Pass',
        4: 'Vip',
        6: 'Call Pass',
        9: 'Coupon',
        15: 'Super Chat Pass'
      }
      let result = 'Chat Pass'
      if (nameMap[type]) {
        result = nameMap[type]
      }
      return result
    },
    // 获取列表
    async handleGetList() {
      try {
        this.goodsLoading = true
        const res = await apiBeerExchangeList()
        const resData = res.propCfgList || []
        this.beerRemainAmount = res.beerRemainAmount || 0
        this.ifExchangeCoinToday = res.ifExchangeCoinToday
        this.goodsList = resData
      } catch (error) {
        console.error(error)
      } finally {
        this.goodsLoading = false
      }
    },
    // 打开兑换弹窗
    handleOpenPopup(item) {
      // 是否已兑换完
      if (item.propType === 0 && this.ifExchangeCoinToday) {
        return false
      }
      // 是否啤酒不够
      if (item.costBeerAmount > this.beerRemainAmount) {
        this.$client.showToast(this.$t('lang.beer.errorText'))
        return false
      }
      let max = Math.floor(this.beerRemainAmount / item.costBeerAmount)
      if (max === 0) max = 1
      if (item.propType === 0) max = 1
      this.maxNumber = max
      this.submitNumber = 1
      this.currentItem = item
      this.popupVisible = true
    },
    // 关闭兑换弹窗
    handleClosePopup() {
      this.popupVisible = false
      setTimeout(() => {
        this.currentItem = {}
      }, 300)
    },

    // 提交兑换
    async handleSubmit() {
      try {
        try {
          this.handleClosePopup()
          const propType = this.currentItem.propType
          const propId = this.currentItem.propId
          await apiBeerExchange(propType, propId, this.submitNumber)
          this.$client.showToast(this.$t('lang.beer.redeemed'))
          this.handleGetList()
          this.handleGetHistory()
        } catch (error) {
          this.$client.showToast(error)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 获取历史记录
    async handleGetHistory() {
      try {
        this.historyFinished = false
        this.historyloading = true
        this.rollParams.offset = 0
        const res = await apiBeerExchangeHistory({ offset: 0, limit: this.rollParams.limit })
        const resData = res || []
        if (Array.isArray(resData)) {
          this.historyList = resData
        } else {
          this.historyFinished = true
        }
        // 返回数量小于limit就说明到底了
        if (resData.length < this.rollParams.limit) {
          this.historyFinished = true
        }
      } catch (error) {
        this.historyFinished = true
        console.error(error)
      } finally {
        this.historyloading = false
      }
    },
    // 获取历史记录-更多
    async handleGetHistoryMore() {
      try {
        if (this.historyList.length === 0) {
          return
        }
        this.historyloading = true
        this.rollParams.offset = this.historyList.length
        const res = await apiBeerExchangeHistory({ offset: this.rollParams.offset, limit: this.rollParams.limit })
        const resData = res || []
        if (Array.isArray(resData) && resData.length > 0) {
          this.historyList = this.historyList.concat(resData)
          // 返回数量小于limit就说明到底了
          if (resData.length < this.rollParams.limit) {
            this.historyFinished = true
          }
        } else {
          this.historyFinished = true
        }
      } catch (error) {
        this.historyFinished = true
        console.error(error)
      } finally {
        this.historyloading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.beer-collect-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #32117a url('./images/beer-bg.png') top center / 100% auto no-repeat;

  .custom-nav-block {
    background: url('./images/beer-bg.png') top left / 100% auto no-repeat;
  }

  .content-wrapper {
    width: 100%;
    .title-wrapper {
      width: 100%;
      font-family: RobotoFlex;
      font-size: 31px;
      text-align: center;
      text-wrap: wrap;
      font-weight: 900;

      background: linear-gradient(90deg, #9cedfd 0%, #ffffff 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;

      padding-top: 4px;
      padding-bottom: 16px;
      padding-left: 16px;
      padding-right: 16px;
    }
    .goods-wrapper {
      width: calc(100% - 44px);
      height: fit-content;
      background-color: #320e81;
      border: 3px solid #6974b4;
      border-radius: 6px;
      overflow: hidden;
      padding: 12px 14px 24px 14px;
      margin: 0px auto;
      .mine-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        height: 30px;
        line-height: 30px;
        padding: 0px 10px;
        margin: 0px auto;
        background-color: #49298e;
        border-radius: 15px;
        overflow: hidden;
        color: #ddd7ff;
      }
      .tips-wrapper {
        width: 100%;
        height: fit-content;
        padding-top: 12px;
        padding-bottom: 16px;
        line-height: 18px;
        font-size: 15px;
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
      }
      .goods-list {
        overflow: hidden;
        width: 100%;
        height: fit-content;
        min-height: 292px;
        .goods-loading-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }
        .goods-item-wrap {
          float: left;
          width: 50%;
          margin-top: 15px;
          padding: 0 8px;
          .goods-item {
            height: fit-content;
            border-radius: 8px;
            position: relative;
            overflow: hidden;
            .item-title {
              font-family: RobotoFlex;
              font-weight: 400;
              font-size: 12px;
              color: #5750a4;
              line-height: 14px;
              text-align: left;
              font-style: normal;
              padding: 8px 8px 0px 8px;
              background-color: #f1eeff;
            }
            .item-image {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 82px;
              background-color: #f1eeff;
              .item-number {
                position: absolute;
                left: 56%;
                bottom: 10px;
                width: fit-content;
                height: 28px;
                font-family: RobotoFlex, RobotoFlex;
                font-size: 20px;
                color: #5750a4;
                line-height: 28px;
                text-align: right;
                font-style: normal;
                text-shadow: 0 -1px 0 white, 0 -2px 0 white, 0 1px 0 white, 0 2px 0 white, -1px 0 0 white, -2px 0 0 white, 1px 0 0 white, 2px 0 0 white;
                font-weight: bold;
                letter-spacing: -1px;
              }
            }
            .item-footer {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 34px;
              background-color: #4928ac;
              color: #ffdf74;
            }
            .item-footer-off {
              background-color: #bcb6c9 !important;
              color: #ffffff !important;
            }
            .shadow-mark {
              position: absolute;
              top: 0;
              z-index: 1;
              width: 100%;
              height: 100%;
              padding: 0px 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              font-size: 15px;
              line-height: 18px;
              text-wrap: wrap;
              text-align: center;
              background-color: rgba(6, 0, 69, 0.7);
              cursor: not-allowed;
              user-select: none;
              pointer-events: none;
            }
          }
        }
      }
    }
    .history-wrapper {
      width: 100%;
      height: fit-content;
      padding-top: 28px;
      .title {
        height: 24px;
        font-family: RobotoFlex, RobotoFlex;
        font-weight: bold;
        font-size: 20px;
        color: #dddddd;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        margin-bottom: 24px;
      }
      .history-list-wrapper {
        width: 100%;
        height: fit-content;
        padding: 0px 24px;
        .list-wrapper {
          width: 100%;
          max-height: 560px;
          overflow-y: auto;
          .history-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 56px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            .item-left {
              display: flex;
              align-items: center;
              justify-content: center;
              width: fit-content;
              height: 100%;
              .item-title {
                color: #dddddd;
                font-size: 15px;
                line-height: 18px;
                font-family: RobotoFlex, RobotoFlex;
                margin-left: 10px;
              }
            }
            .item-right {
              display: flex;
              align-items: flex-end;
              flex-direction: column;
              width: fit-content;
              height: fit-content;
              .item-info {
                display: flex;
                align-items: center;
                justify-content: center;
                width: fit-content;
                height: 22px;
                text-align: end;
                color: #dddddd;
                line-height: 22px;
              }
              .item-time {
                color: rgba(255, 255, 255, 0.5);
                line-height: 14px;
                font-size: 12px;
                font-family: RobotoFlex, RobotoFlex;
              }
            }
          }
        }
      }
    }
  }
}

// 弹窗
.dialog-wrapper {
  width: 315px;
  height: 342px;
  background-color: #fdfdfd;
  border-radius: 12px;
  padding: 30px 24px;
  overflow: hidden;
  .title-wrapper {
    font-family: RobotoFlex, RobotoFlex;
    font-weight: normal;
    font-size: 17px;
    color: #333333;
    line-height: 20px;
    text-align: center;
    font-style: normal;
  }
  .content-wrapper {
    width: 100%;
    height: calc(100% - 132px);
    .image-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 40px;
      margin-top: 16px;
      margin-bottom: 10px;
    }
    .text-wrapper {
      height: 18px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      margin-bottom: 16px;
    }
    .number-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: fit-content;
    }
  }
  .footer-wrapper {
    width: 100%;
    height: fit-content;
    .button-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 48px;
      border-radius: 24px;
      overflow: hidden;
      font-size: 15px;
      line-height: 18px;
    }
    .confirm {
      color: #ffffff;
      background-color: #a338fc;
      margin-bottom: 16px;
    }
    .cancel {
      color: #a338fc;
      border: 1px solid #a338fc;
    }
  }
}
</style>

<style lang="scss">
.custom-p-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.beeract-title-beer {
  width: 32px;
  height: 32px;
  margin: 0 4px;
}

.beeract-tips-beer {
  width: 20px;
  height: 20px;
  margin: 0 6px;
}

.beeract-histit-beer {
  width: 30px;
  height: 30px;
  margin: 0 6px;
}

.beer-van-dia {
  width: 315px;
}
</style>
